<!-- 商家端 - 订单中心 -->
<template>
  <ContentWrap :body-style="{ padding: '0 16px', overflow: 'visible' }">
    <el-tabs v-model="activeTab" class="order-center-tabs" @tab-change="onTabChange">
      <el-tab-pane label="订单管理" name="order" />
      <el-tab-pane label="售后退款" name="aftersale" />
      <el-tab-pane label="退定审核" name="depositCancel" />
    </el-tabs>
  </ContentWrap>

  <!-- 不 KeepAlive 售后页，避免热更新后仍缓存旧列表逻辑 -->
  <OrderList v-if="activeTab === 'order'" key="order" />
  <AfterSaleList v-else-if="activeTab === 'aftersale'" key="aftersale" />
  <DepositCancelList v-else key="depositCancel" />
</template>

<script setup lang="ts">
import OrderList from './OrderList.vue'
import AfterSaleList from './AfterSaleList.vue'
import DepositCancelList from './DepositCancelList.vue'

defineOptions({ name: 'MerchantOrderCenter' })

const activeTab = ref('order')
const onTabChange = () => {}
</script>

<style scoped>
.order-center-tabs :deep(.el-tabs__header) {
  margin-bottom: 0;
}
.order-center-tabs :deep(.el-tabs__nav-wrap::after) {
  height: 1px;
}
</style>
